export default __webpack_public_path__ + "static/media/list_event_banner01.03e59b96.png";